// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import style from './ProductBox.scss'

import type { Product } from '../../duck';

type Props = {
  +product: Product;
};

export default class ProductBox extends Component<Props> {
  render() {
    const { product } = this.props;
    const link = product.encoded ? `/new-order/product?product=${product.encoded}` :
      `/new-order/product?initialQuery=${product.url}`;
    return (
      <Link to={link} className={style.productBox}>
        <img src={product.image} alt=""/>
        <section className={style.contentWrap}>
          <article className={style.content}>
            <section className={style.info1}>
              <p className={style.name}>{product.name}</p>
              {/*<img src="" alt="Qempo"/>*/}
            </section>
            <div className={style.vl}/>
            <section className={style.info2}>
              {product.freeShipping && <FormattedMessage id="featuredProducts.filter.freeShipping">{
                txt => <p className={style.freeOption}>+ {txt}</p>
              }</FormattedMessage>}
              {product.taxFree && <FormattedMessage id="featuredProducts.filter.taxFree">{
                txt => <p className={style.freeOption}>+ {txt}</p>
              }</FormattedMessage>}
              <p className={style.price}>${product.price}</p>
            </section>
          </article>
        </section>
      </Link>);
  }
}

ProductBox.propTypes = {
  product: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/featured-products/components/ProductBox/ProductBox.jsx